import { useMemo } from 'react'

import { FixedBanner } from '@circlefin/components'
import { useTravelRuleRequired } from '@features/users/hooks/travel-rule'
import useTranslation from 'next-translate/useTranslation'

import type { Blockchain } from '@shared/graphql'

export interface TravelRuleNonTrmBannerProps {
  /**
   * Selected blockchain.
   */
  blockchain?: Blockchain
}

export const TravelRuleNonTrmBanner: React.FC<TravelRuleNonTrmBannerProps> = ({
  blockchain,
  ...props
}) => {
  const { t } = useTranslation('address-book/components')
  const { jurisdiction, travelRuleRequired } = useTravelRuleRequired()

  const visible = useMemo(
    () =>
      travelRuleRequired &&
      blockchain !== undefined &&
      !blockchain.isTRMSupported,
    [blockchain, travelRuleRequired],
  )

  return (
    <FixedBanner status="info" visible={visible} {...props}>
      {t(`travelRuleTrmDisclaimer`, {
        jurisdiction,
      })}
    </FixedBanner>
  )
}
